import React, { useCallback, useState } from "react";
import Carousel, { Modal, ModalGateway } from "react-images";
import Gallery from "react-photo-gallery";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetGalleryQuery } from '../../store';

export default function GalleryView() {

    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const token = useSelector((state) => state.environment.token);
    const navigate = useNavigate();
    const { data } = useGetGalleryQuery();

    const isEditMode = !!token;

    const openLightbox = useCallback((_event, { index }) => {

        if (isEditMode) {

            const photoId = _event.target.attributes.id.value;
            const photoPath = `/photo/${photoId}`;
            navigate(photoPath);
        }

        setCurrentImage(index);
        setViewerIsOpen(true);
    }, []);

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const newPhotoModel = {
        id: 0,
        src: 'data:image/jpeg;base64,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',
        title: '',
        height: 1,
        width: 1
    };

    const contextData = data || [];
    const photos = token ? [newPhotoModel, ...contextData] : contextData;

    const sourcePhotos = photos.map(x => {
        return {
            id: x.id,
            src: x.src,
            height: x.height,
            width: x.width,
            title: x.title
        };
    });

    return (
        <div>
            <Gallery photos={sourcePhotos} onClick={openLightbox} />
            <ModalGateway>
                {viewerIsOpen ? (
                    <Modal onClose={closeLightbox}>
                        <Carousel
                            currentIndex={currentImage}
                            views={photos.map((x) => ({
                                ...x,
                                srcset: x.srcSet,
                                caption: x.title
                            }))}
                        />
                    </Modal>
                ) : null}
            </ModalGateway>
        </div>);
}